import React, { useState, useEffect } from 'react';

import HeroContentType from 'containers/user/learn/components/hero-content-type/hero-content-type';
import NothingFound from 'containers/user/learn/components/empty-row/empty-row';
import Cards from 'containers/user/learn/components/cards/cards';
import Loader from 'components/partials/loader/loader';
import SeeMoreButton from 'containers/user/learn/components/see-more-btn/see-more-btn';

import api from 'api';

import { useCurrentUser } from 'state/current-user/current-user.thunk';

interface ReleaseNoteCardItem {
  name?: string;
  route: string;
  coverDescription?: string;
  coverImage?: string;
  date?: string;
}

interface ReleaseNoteApiEntry {
  id: string | number;
  attributes?: {
    name?: string;
    coverDescription?: string;
    coverImage?: { data?: { attributes?: { url?: string } } };
    releaseNotesDate?: string;
  };
}

const ProductAnnouncements = (): React.JSX.Element => {
  const [releaseNotes, setReleaseNotes] = useState<ReleaseNoteCardItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [displayAll, setDisplayAll] = useState<boolean>(false);

  const user = useCurrentUser();

  useEffect(() => {
    setLoading(true);
    api
      .getReleaseNotes(user?.data?.oktaUserId ?? '')
      .then((res) => {
        const data = (res as { data?: { data?: ReleaseNoteApiEntry[] } })?.data?.data;
        const sortedReleaseNotes = data
          ?.map((el) => ({
            name: el.attributes?.name,
            route: `/learn/content/product-announcements/${el.id}`,
            coverDescription: el.attributes?.coverDescription,
            coverImage: el.attributes?.coverImage?.data?.attributes?.url,
            date: el.attributes?.releaseNotesDate,
          }))
          .sort((a, b) => {
            const dateA = a.date ? new Date(a.date) : new Date(0);
            const dateB = b.date ? new Date(b.date) : new Date(0);

            return dateB.getTime() - dateA.getTime();
          });

        setReleaseNotes(sortedReleaseNotes || []);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const displayedReleaseNotes = displayAll
    ? releaseNotes
    : releaseNotes.slice(0, 3);

  return (
    <div className="w-full">
      <Loader loading={loading} />
      <HeroContentType
        title="Product Announcements"
        description="Stay up-to-date with the latest MARKETview Product Updates."
        breadcrumbs={[
          { label: 'Learn', href: '/learn' },
          { label: 'Product Announcements', isActive: true },
        ]}
        customClass="pt-5"
      />
      <div className="flex flex-col items-center mt-10">
        {!displayedReleaseNotes.length && !loading ? (
          <NothingFound contentType="Product Announcements" />
        ) : (
          <Cards items={displayedReleaseNotes} contentType="Release Note" />
        )}

        {releaseNotes.length > 3 && (
          <SeeMoreButton
            onClick={() => setDisplayAll(!displayAll)}
            showAll={displayAll}
          />
        )}
      </div>
    </div>
  );
};

export default ProductAnnouncements;
